import { ClientQuototationType } from '@app/interfaces/client-quotation.model';

const QuotationType :any = {
  TIERED_PRICING: 'tiered_pricing',
  STANDARD: 'standard',
};

const QuotationLineItemType :ClientQuototationType = {
  TIERED_PRICING: 'tiered_pricing',
  STANDARD: 'standard',
  CUSTOM: 'custom',
};

export const ClientQuotationConstant :any = {
  QuotationType,
  QuotationLineItemType,
};
